import { upperFirst } from 'lodash';

import { TextRegular } from 'UiKit/typography';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import ActionButton from 'View/role/components/action-button';
import PermissionsBadge from 'View/role/components/permission-badge';

import styles from './styles.module.css';

const buildTableList = (t) => {
  const accessPermission = getMenuPermissions('master-data', 'access');

  const tableList = [
    {
      name: t('tableColumnRoleName'),
      key: 'name',
      width: 250,
      sortKey: 'name',
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{upperFirst(value)}</TextRegular>,
    },
    {
      name: t('tableColumnPermissionList'),
      key: 'permissions',
      width: 700,
      component: ({ value, values }) => <PermissionsBadge permissions={value} accessPermission={accessPermission} id={values?.id} />,
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: t('tableColumnAction'),
      key: 'id',
      width: 150,
      position: 'center',
      component: ({ value }) => <ActionButton value={value} />,
    });
  }

  return tableList;
};

export default buildTableList;